import Slider from '../src/slider';
import Map from '../src/map';
import {Size} from '../src/core/utils';
import 'jquery';


export default function page_contatti(app) {

    /**********************************************/
    //
    // MAP
    //
    /**********************************************/
    // Google maps
    var myMap = new Map('map', new Map.Coordinates(45.7324280,9.1450980), {
        markerEnabled: true,
        infoWindowText: "Sergio Bianchi Studio di Architettura",
        marker: {
            enabled: true,
            position: null,
            title: "Marker title",
            image: themeUrl + "assets/img/contatti/map-marker.png",
            imageSize: new Size(40, 54),
            infoWindowContent: app.lang.get("address")
        },
        geolocation: {
            enabled: true,
            infoWindowContent: app.lang.get("tua_posizione")
        },
        mapStyle: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
    }, myMapOptionsCustomizer);

    // Personalizzo le opzioni mappa
    // Questo callback viene richiamato solo quando necessario
    function myMapOptionsCustomizer(mapOptions) {
        mapOptions.zoom = 11;
        mapOptions.streetViewControlOptions = {
            position: google.maps.ControlPosition.LEFT_CENTER
        };

        return mapOptions;
    }

    window.myMap = myMap;
}



/** WEBPACK FOOTER **
 ** ./assets/scripts/views/page_contatti.js
 **/